module.exports = __webpack_public_path__ + "c22a58657fb0b27dcce7d73e875f4951.svg";